<div class="flex flex-col items-center wrapper">
  <div class="flex items-center loader-container">
    <mat-progress-spinner class="inner-stroke" [value]="100" [strokeWidth]="2" [color]="'warn'"></mat-progress-spinner>

    <mat-progress-spinner appCircularProgressBarGradient
                          class="outer-stroke"
                          [value]="percent"
                          [strokeWidth]="2.1">
    </mat-progress-spinner>

    <div class="flex flex-col items-center inner-content" [ngClass]="{'alert': metricInfo.hasError}">
      <img [src]="metricInfo.iconHref"/>
      <div class="white-fg mat-headline-4 mb-30">{{metricInfo.text}}</div>
    </div>
  </div>
</div>
